import React from 'react';
import { useAlert } from 'react-alert';
import { Auth } from 'aws-amplify';
import * as Yup from 'yup';
import { ErrorMessage, Field, Formik } from 'formik';
import Base, { ContentContainer } from '../../components/Base';
import { Button, ButtonActionBack, DivActionBack, Form, FormControl, H1, ImgIconBack, InputError } from '../../assets/styles/GlobalStyles';
import { verifyError } from '../../utils/verifyErrors';
import { Input } from '../../components/Base/Elements';
import IconBack from "../../assets/icon/icon-back.svg";
import { BgSelectAppWebForm, LogoContainer } from "../../components/Base/styled";
import LogoAppWebSelectFarm from "../../assets/images/fundo-rosa-cima.png";
import { translate } from '../../i18n/index';

const ForgotPasswordStore = ({ history }) => {
    const alert = useAlert();

    function handleClickForgotPassword() {
        history.push({
            pathname: '/login',
            search: history.location.search,
        });
    }

    return (
        <>
            <DivActionBack>
                <ButtonActionBack onClick={() => handleClickForgotPassword()} type="button">
                    <ImgIconBack src={IconBack} className="icon-back" alt="Button Back" />{translate('buttonActionBack')}
                </ButtonActionBack>
            </DivActionBack>
            <div>
                <LogoContainer
                    style={{ alignSelf: 'center' }}
                    rel="noopener noreferrer"
                    target="_self">
                    <BgSelectAppWebForm src={LogoAppWebSelectFarm} alt="Logo OnFarm" title="OnFarm" />
                </LogoContainer>
            </div>
            <Base width={430} isStore={true} backgroundForm={'#fff'}>
                <ContentContainer>
                    <Formik
                        enableReinitialize
                        initialValues={{
                            username: '',
                        }}
                        validationSchema={Yup.object().shape({
                            username: Yup.string().required(translate('validateRequired')),
                        })}
                        onSubmit={async (values, actions) => {
                            if (values) {
                                try {
                                    await Auth.forgotPassword(values.username);
                                    alert.show(translate('forgotPasswordExceptionCodeSendingSuccess'), {
                                        closeCopy: 'Fechar',
                                    });
                                    history.push({
                                        pathname: '/recuperar-senha',
                                        search: history.location.search,
                                        state: {
                                            username: values.username,
                                        },
                                    });
                                } catch (e) {
                                    if (e.code === 'InvalidParameterException') {
                                        alert.show(translate('forgotPasswordExceptionContactVerifiedRequired'), {
                                            closeCopy: 'Fechar',
                                        });
                                    } else {
                                        alert.show(verifyError(e.code, e.message), {
                                            closeCopy: 'Fechar',
                                        });
                                    }
                                }
                            }
                            actions.setSubmitting(false);
                        }}>
                        {({ isSubmitting }) => (
                            <Form>
                                <H1
                                    style={{
                                        marginBottom: '20px',
                                        lineHeight: '25px',
                                        fontSize: '15px',
                                    }}>
                                    {translate('forgotPasswordTitle')}
                                </H1>
                                <FormControl>
                                    <Field
                                        autocapitalize="off"
                                        name="username"
                                        placeholder={translate('inputUsername')}
                                        component={Input}
                                    />
                                    <ErrorMessage name="username" component={InputError} />
                                </FormControl>
                                <FormControl>
                                    <Button type="submit" disabled={isSubmitting}>
                                        {isSubmitting ? translate('buttonSending') : translate('buttonSend')}
                                    </Button>
                                </FormControl>
                            </Form>
                        )}
                    </Formik>
                </ContentContainer>
            </Base>
        </>
    );
};

export default ForgotPasswordStore;
